<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	
	<div class="page_header">
		<h1 class="heading">Manage {{this.lblHeading}}</h1>
	</div>

	<app-filter [code]="code" [description]="description" [selectedItems]="selectedItems"
		(formValueChanged)="applyFilter($event)"></app-filter>

	<!-- <div class="row">
		<div class="col-md-12">
			<app-search [placeholder]="placeholder"></app-search>
		</div>
	</div> -->

	<ng-template #content let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title"> Delete Confirmation</h4>
			<button type="button" class="btn-close" aria-label="Close"
				(click)="modal.dismiss('Cross click')">&times;</button>
		</div>
		<div class="modal-body">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
		</div>
		<div class="modal-footer">
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')"
				style="width:80px;">No</button>
		</div>
	</ng-template>

	<div class="row">
		<div *ngIf="isRemove" class="text-danger col-md-12">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
		</div>
		<div class="col-md-12" *ngIf="!isRemove">

			<!-- Add List Permit Type Button -->
			<!-- <div class="btn-wrap">
        <button [routerLink]="['/permit/type/add']" type="button" class="add-btn"> Add </button>
      </div> -->

			<!-- Permit Table Actions -->
			<app-actions [actions]="permitTypeActions" (actionEvent)="doPermitAction($event)"
				[selectedPermitData]="selectedPermitData"></app-actions>

			<!-- Permit type List Table -->

			<div class="table-responsive">
				<table class="table table-sm custom_table">
					<thead class="thead-inverse">
						<tr class="hdclpse">
							<th>Select</th>
							<th class="bfr-end-col">
								Code<i style="vertical-align:middle; " class="fa fa-sort"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">Description</th>
							<th class="bfr-end-col">Temp or Long-Term</th>
							<th class="bfr-end-col">Freight or Passenger</th>
							<th class="bfr-end-col text-right">
								App Fee<i style="vertical-align:middle; " class="fa fa-sort"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col text-right">
								Permit Fee<i style="vertical-align:middle; " class="fa fa-sort"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">
								Active?<i style="vertical-align:middle; " class="fa fa-sort"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="let pType of pTypes  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
							<td><input type="checkbox" value="{{item}}" (change)="CheckedPermit($event,pType)"></td>
							<td class="bfr-end-col">{{pType.code}}</td>
							<td class="bfr-end-col">{{pType.description}}</td>
							<td class="bfr-end-col">{{showIndicator(pType.temp_long_ind,2)}}</td>
							<td class="bfr-end-col">{{showIndicator(pType.freight_passenger_ind)}}</td>
							<td class="bfr-end-col text-right">{{(pType.current_application_fee)? (pType.current_application_fee |
								currencyFormat):'R0'}}</td>
							<td class="bfr-end-col text-right">{{(pType.current_fee)? (pType.current_fee| currencyFormat):'R0'}}
							</td>
							<td class="bfr-end-col">{{utility.isActive(pType.is_active)}}</td>
						</tr>
					</tbody>

					<tfoot>
						<tr *ngIf="pTypes.length > 4" class="pagination_row">
							<td colspan="8" class="rm-brd">
								<div class="row">
									<div class="col-4">
										<div class="input-group mb-3 rm-brd"
											style="width:125px!important;height:30px!important;">
											<div class="input-group-prepend">
												<label class="input-group-text form-control-sm show-h" for="show-id"
													>Show:</label>
											</div>
											<select class="form-control form-control-sm show-h" id="show-id"
												[(ngModel)]="showNum">
												<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
												</option>
											</select>
										</div>
									</div>
									<div class="col-8 text-right">
										<pagination-controls (pageChange)="utility.page = $event"
											style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="isEmpty">
							<td colspan="8" class="rm-brd text-center">
								<span class="text-info text-small">No Permit types found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>

			<!-- <p-table #tbpTypes [value]="pTypes" [rows]="10" [rowsPerPageOptions]="[10,25,50]"
        styleClass="p-datatable-customers" [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0">
        <ng-template pTemplate="header">
          <tr>
            <th>Code</th>
            <th style="word-wrap: break-word">Description</th>
            <th style="word-wrap: break-word">Temp or Long-term</th>
            <th style="word-wrap: break-word">Freight or Passenger</th>
            <th style="word-wrap: break-word">App Fee</th>
            <th style="word-wrap: break-word">Permit Fee</th>
            <th style="word-wrap: break-word">Active?</th>
            <th>
              Actions
            </th>
          </tr>
        </ng-template>
        <tr>
          <th>
            <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'code', 'contains')"
              placeholder="Code" class="form-control">
          </th>
        </tr>
        <ng-template pTemplate="body" let-pType>
          <tr>
            <td class="bfr-end-col">{{pType.code}}</td>

            <td class="bfr-end-col">{{pType.description}}</td>

            <td class="bfr-end-col">{{showIndicator(pType.temp_long_ind,2)}}</td>

            <td class="bfr-end-col">{{showIndicator(pType.freight_passenger_ind)}}</td>

            <td class="bfr-end-col">{{(pType.current_application_fee)? (pType.current_application_fee |
              currencyFormat):'R0'}}</td>

            <td class="bfr-end-col">{{(pType.current_fee)? (pType.current_fee| currencyFormat):'R0'}}</td>

            <td class="bfr-end-col">{{utility.isActive(pType.is_active)}}</td>

            <td class="btn-show bfr-end-col end-col">
              <a [routerLink]="['/permit/type/edit',pType.id]">
                <span title="Edit Permit Type" style="margin-right: 10px; color:#00236F;"><i
                    class="fa fa-pencil fa-fw"></i></span></a>
              <span title="Delete Permit Type" style="margin-right: 10px; color:#00236F;" (click)="onConfirm(pType, content)"><i
                  class="fa fa-trash fa-fw"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table> -->

		</div>
	</div>
</div>